import {type ISavedCart} from '../schema';

export const canDuplicateSavedCart = (savedCart?: ISavedCart) => !!savedCart;

export default canDuplicateSavedCart;
